import { StringUtil } from '@nomidio/common';

export enum AuthLevel {
  Standard = 'STANDARD',
  High = 'HIGH',
}

export function AuthLevelPresentation(level: AuthLevel): string {
  switch (level) {
    case AuthLevel.High:
      return 'High';
    case AuthLevel.Standard:
      return 'Standard';
    default:
      console.warn(`Unrecognised auth level '${level}' requested for presentation`);
      return StringUtil.toPresentationFormat(level);
  }
}
